module.exports = __webpack_public_path__ + "img/pin-in-6.c10df792.svg";